<template>
  <div class="goodLists">
    <HeadBack title="店铺数字权益" />
    <div class="rightWrap">
      <!-- 兑换协议 -->
      <span class="question" @click="showRlue">?</span>
      <!-- <i class="el-icon-edit" @click="showRlue"></i> -->
      <!-- <van-icon name="question-o" size="21" color="#333333" @click="showRlue"/> -->
    </div>
    <div class="cententsWrap">
      <el-table
        ref="tableData"
        :data="goodList"
        :header-cell-style="{background:'#424556',padding:'20px 40px'}"
        style="width: 100%;height:100%;"
      >
        <template slot="empty">
          <div v-if="isNetWrong" class="no-datas1"><div class="no-data-img" style="margin: 200px auto 0px; width: 100px; height: 400px;"><img src="@/assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div></div>
          <div v-else class="no-datas1"><div class="no-data-img" style="margin: 200px auto 0px; width: 100px; height: 100px;"><img src="@/assets/images/no_data.png" alt="" style="width: 100%;"></div><div class="no-data" style="margin-top: -15px !important; text-align: center;">暂无数据</div></div>
        </template>
        <el-table-column
          prop="logoUrl"
          label="店铺LOGO"
          min-width="100"
        >
          <template slot-scope="scope">
            <img :src="scope.row.logoUrl" alt="" style="width:80px;height:80px;border-radius:8px;border:1px solid #E6E6E6;">
          </template>
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="店铺数字权益名称"
          min-width="135"
        >
        </el-table-column>
        <el-table-column
          prop="commodityCode"
          label="代码"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="balance"
          label="数量"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="兑换茶资产"
          min-width="100"
          align="right"
        >
          <template slot-scope="scope">
            <p class="exchangSty"><span @click="openExchange(scope.row)">去兑换</span></p>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>

    <!-- show-cancel-button confirmButtonText="兑换" @confirm="sureExchange" -->
    <el-dialog :visible.sync="showExchange" width="480px" class="exchangeDialog">
      <div>
        <div class="title">兑换{{ chooseExchange.commodityName }}</div>
        <div class="oneRows">
          <p class="name">兑换价格</p>
          <p class="num">{{ newPrice ? newPrice : marketPrice }}</p>
        </div>
        <div class="twoRows">
          <el-input
            ref="exchangeNums"
            v-model.number="exchangeNum"
            label=""
            :border="false"
            type="number"
            center
            placeholder="输入兑换数量"
            @input="numssCheck($event)"
          >
            <template slot="append">个</template>
          </el-input>
        </div>
        <div v-if="exchangeNum" class="fourRows">
          <p class="name">共计使用店铺数字权益</p>
          <p class="num">{{ totalPirce }}个</p>
        </div>
        <div class="threeRows">
          <el-checkbox v-model="checked" shape="square" checked-color="#0A51F7" icon-size="16px">
            我已阅读并同意
          </el-checkbox>
          <b @click="showAgreement">&nbsp;《兑换协议》</b>
        </div>
        <div class="actionWrap">
          <span class="btns" @click="closeExchange()">取消</span>
          <span class="savebtn" @click="sureExchange()">确定</span>
        </div>
      </div>
    </el-dialog>
    <exchangeAgree ref="agreementOpen" @confirm="confirmAgree" />
    <questionA ref="questionOpen" />
  </div>
</template>
<script>
/*global http protocol util*/
import exchangeAgree from '@/components/base/entryAgreement/exchangeAgree.vue'
import questionA from '@/components/base/entryAgreement/questionA.vue'
import { mapGetters } from 'vuex'
import HeadBack from '@/components/base/header/HeadBack.vue'
export default {
  components: {
    HeadBack,
    exchangeAgree,
    questionA
  },
  data() {
    return {
      isNetWrong: false,
      goodList: [],
      // 分页相关
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        currentPage: 1
      },
      showExchange: false,
      checked: false,
      exchangeNum: null,
      chooseExchange: {},
      isRepeat: false,
      marketPrice: 0
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'marketDetails'
    ]),
    newPrice() {
      if (this.chooseExchange !== {}) {
        let n = 0
        for (let i = 0; i < this.marketDetails.length; i++) {
          // eslint-disable-next-line eqeqeq
          if (this.marketDetails[i].symbolId == this.chooseExchange.quoCommodityId) {
            return this.marketDetails[i].close
          } else {
            n++
          }
        }
        if (n === this.marketDetails.length) {
          this.getIncubation()
        }
      }
      return 0
    },
    totalPirce() {
      if ((this.newPrice || this.marketPrice) && this.exchangeNum) {
        const price = this.newPrice ? this.newPrice : this.marketPrice
        return util.floatMul(price, this.exchangeNum)
      }
      return 0
    }
  },
  mounted() {
    this.getCommoditye()
  },
  methods: {
    goPath() {
      this.$router.push('/orderCenter')
    },
    showRlue() {
      this.$refs.questionOpen.showDia()
    },
    // 查询孵化
    getIncubation() {
      protocol.param_findHatch.param.page = 0
      protocol.param_findHatch.param.size = 1
      protocol.param_findHatch.param.commodityId = this.chooseExchange.quoCommodityId
      protocol.param_findHatch.param.sort = [{
        'direction': 'DESC',
        'property': 'createTime'
      }]
      http.postFront(protocol.param_findHatch).then(res => {
        if (res && res.data) {
          const { code, message, value } = res.data
          if (Number(code) === 0) {
            if (value.totalElements > 0) {
              this.marketPrice = value.content[0].marketPrice
            } else {
              this.marketPrice = 0
            }
          } else {
            this.marketPrice = 0
            this.$message(message)
          }
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getCommoditye()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getCommoditye()
    },
    getCommoditye() {
      protocol.param_findShopCoin.param.page = this.pageData.currentPage - 1
      protocol.param_findShopCoin.param.size = this.pageData.pageSize
      protocol.param_findShopCoin.param.commodityId = null
      http.postFrontMall(protocol.param_findShopCoin).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          this.pageData.total = value.totalElements
          this.isNetWrong = false
          this.goodList = value.content
        } else {
          this.$message({ message: message })
          this.isNetWrong = true
          this.goodList = []
        }
      }).catch(() => {

      })
    },
    openExchange(item) {
      this.chooseExchange = item
      this.checked = false
      this.showExchange = true
    },
    confirmAgree() {
      this.checked = true
    },
    showAgreement() {
      // this.$message('暂无协议')
      this.$refs.agreementOpen.showDia()
    },
    closeExchange() {
      this.showExchange = false
      setTimeout(() => {
        this.exchangeNum = null
        this.chooseExchange = {}
      }, 500)
    },
    isEmpty(param) {
      if (param === null || param === undefined || param === '') {
        return true
      } else {
        return false
      }
    },
    numssCheck(val) {
      val = val.replace(/。/g, '.')
      val = val.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
      val = val.replace(/^\./g, '') // 验证第一个字符是数字
      val = val.replace(/\.{2,}/g, '') // 只保留第一个, 清除多余的
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
      this.exchangeNum = val // 在进行赋值
    },
    sureExchange() {
      // 确认兑换
      if (this.isRepeat) {
        return
      }
      if (this.isEmpty(this.exchangeNum)) {
        this.$message('请输入兑换数量')
        return
      }
      if (Number(this.exchangeNum) <= 0) {
        return this.$message('兑换数量需大于0')
      }
      if (!this.checked) {
        this.$message({
          type: 'warning',
          message: '请勾选阅读并同意兑换协议'
        })
        return
      }
      this.isRepeat = true
      protocol.param_integralExchange.param = {
        commodityId: this.chooseExchange.quoCommodityId,
        userId: this.chooseExchange.userId,
        quantity: Number(this.exchangeNum)
      }
      http.postFront(protocol.param_integralExchange).then(response => {
        const { code, message } = response.data
        if (Number(code) == 0) {
          this.$message(message)
          // this.isRepeat = false
          // this.showExchange = false
          setTimeout(() => {
            this.isRepeat = false
            this.showExchange = false
            this.exchangeNum = null
            this.chooseExchange = {}
            this.goodList = []
            this.getCommoditye()
          }, 1000)
        } else {
          this.$message(message)
          this.isRepeat = false
        }
      }).catch(() => {
        this.isRepeat = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.goodLists{
    height:100%;
    min-height: 100vh;
    .rightWrap{
      position: fixed;
      z-index:99999;
      top:12px;
      right: 14px;
      cursor: pointer;
      .question{
        display: inline-block;
        width:16px;
        height: 16px;
        border-radius: 50%;
        border:1px solid #fff;
        line-height: 16px;
        text-align: center;
        font-size:14px;
        color:#fff;
      }
    }
    .cententsWrap{
        width:1200px;
        height: 75vh;
        margin: 80px auto;
    }
    .el-pagination{
      margin-top:20px;
        text-align:center;
    }
   .el-table, .el-table__expanded-cell{
    background-color:#343646;
   }
   .cententsWrap .el-table .cell .exchangSty{
    display: inline-block;
    width:100%;
    text-align: right;
    span{
        cursor: pointer;
        font-size: 20px;
        font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
        font-weight: 500;
        color: #E4CA91;
    }
   }

}
.exchangeDialog{
  /deep/input, /deep/.el-input__inner, /deep/.el-input-group__append{
    background: #292C3A;
    border:1px solid #292C3A!important;
    font-size: 20px;
    font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
    font-weight: normal;
    color: #FFFFFF;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner, /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #E4CA91;
    border-color: #E4CA91;
  }
  /deep/.el-checkbox__inner::after{
    box-sizing: content-box;
    content: "";
    border: 1px solid #5E4207;
    border-left: 0;
    border-top: 0;
    height: 11px;
    left: 7px;
    position: absolute;
    top: 1px;
    // transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform .15s ease-in .05s;
    transform-origin: center;
  }
  /deep/.el-checkbox__input.is-focus .el-checkbox__inner{
    border-color:transparent;
  }
  /deep/.el-input-group__append{
    font-size: 16px;
    font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
    font-weight: bold;
    color: #FFFFFF;
  }
  /deep/.el-dialog{
		background: #424556!important;
		border-radius: 8px 8px 8px 8px;
	}
	/deep/.el-dialog__header{
		display: none;
	}
	/deep/.el-dialog__body{
		padding:40px;
	}
	.title{
		font-size: 24px;
		font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
		font-weight: bold;
		color: #FFFFFF;
		text-align: center;
	}
    .oneRows{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top:10px;
        .name{
          font-size: 16px;
          font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
          font-weight: 400;
          color: #C5C5C5;
          line-height: 19px;
        }
        .num{
          font-size: 20px;
          font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
          font-weight: normal;
          color: #FFFFFF;
          line-height: 23px;
        }
    }
    .fourRows{
      margin-top:10px;
      padding:0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 45px;
      background: #292C3A;
      border-radius: 4px 4px 4px 4px;
      .name{
        font-size: 18px;
        font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
        font-weight: bold;
        color: #FFFFFF;
      }
      .num{
        font-size: 20px;
        font-family: ITC Avant Garde Gothic Pro-Demi, ITC Avant Garde Gothic Pro;
        font-weight: normal;
        color: #FFFFFF;
      }
    }
    .twoRows{
        margin-top:10px;
        /deep/.van-cell{
            background: #F8F9FB;
            border-radius: 4px 4px 4px 4px;
        }
        /deep/ input::-webkit-outer-spin-button,
        /deep/ input::-webkit-inner-spin-button {
            -webkit-appearance: none !important;
            }
        /deep/ input[type='number'] {
            -moz-appearance: textfield !important;
            }
    }
    .threeRows{
        display: flex;
        margin:20px 0 0;
        font-size: 16px;
        font-family: PingFang HK-Regular, PingFang HK;
        font-weight: 400;
        color: #999999;
        line-height: 19px;
        align-items: center;
        /deep/.el-checkbox__inner{
          width:18px;
          height: 18px;
        }
        /deep/.el-checkbox__label{
          font-size: 18px;
          font-family: PingFang HK-Medium, PingFang HK;
          font-weight: 500;
          color: #FEFFFE;
          line-height: 21px;
        }
        b{
            cursor: pointer;
            color:#E4CA91;
            font-weight: normal;
        }
    }
	.actionWrap{
		margin-top:40px;
		display: flex;
		justify-content: center;
		.btns{
			display: inline-block;
			width: 95px;
			height: 40px;
			background: #FCECC8;
			border-radius: 4px 4px 4px 4px;
			border: 1px solid #E4CA91;
			font-size: 14px;
			font-family: PingFang HK-Medium, PingFang HK;
			font-weight: 500;
			color: #5E4207;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
		}
	}

	.savebtn{
		margin-left: 20px;
		width:95px;
		display: inline-block;
		height: 40px;
		background: #E4CA91;
		border-radius: 4px 4px 4px 4px;
		font-size: 14px;
		font-family: PingFang HK-Medium, PingFang HK;
		font-weight: 500;
		color: #5E4207;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
	}
}
</style>
<style>

  .cententsWrap  .el-table th.el-table__cell>.cell{
    font-size: 20px;
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 500;
    color: #FFFFFF;
    padding:0;
    text-align: left;
   }
  .cententsWrap .el-table td.el-table__cell, .cententsWrap .el-table th.el-table__cell.is-leaf{
      border-bottom: none;
   }
   .cententsWrap .el-table .cell{
    font-size: 20px;
    font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
    font-weight: 500;
    color: #FFFFFF;
    padding: 0 40px;
   }
   .cententsWrap .el-table table tr, .cententsWrap .el-table th{
    background-color:#343646;
   }
   .cententsWrap .el-table .el-table__cell.is-right .cell{
    text-align: right;
   }
   .cententsWrap .el-table__header-wrapper td.el-table__cell, .cententsWrap .el-table__header-wrapper th.el-table__cell.is-leaf{
     border-bottom:none;
   }
   .cententsWrap .el-table__body-wrapper .el-table__row{
     position: relative;
   }
   .cententsWrap .el-table__body-wrapper .el-table__row::after{
     content:'';
     position: absolute;
     width:1120px;
     left:40px;
     bottom:0;
     height:2px;
     background-color: #777A89;
   }
   .cententsWrap .el-pagination button:disabled,
   .cententsWrap .el-pagination .btn-prev,
   .cententsWrap .el-pagination .btn-next,
   .cententsWrap .el-pager li,
   .cententsWrap .el-pagination__editor.el-input .el-input__inner,
   .cententsWrap .el-pagination .el-select .el-input .el-input__inner {
         background: #141625;
    }
</style>
